import { Stack, Typography } from '@mui/joy';
import { useTranslation } from 'react-i18next';

import { Tooltip } from 'core/elements';
import { Color, Direction, Level, TooltipPosition } from 'theme/enums';

import { ManageNotesButton } from './ManageNotes';
import { Notes } from './Notes';
import { NotesMoreWrapper } from './style';
import { IManagedNote, INoteProps } from './types';

interface IProps {
  compactPartNotes: IManagedNote[];
  totalNotes: IManagedNote[];
  hasManageNotes?: boolean;
  addButton?: JSX.Element;
  listAddButton?: JSX.Element;
  manageNotesIsOpenExternal?: boolean;
  updateManageNotesIsOpenExternal?: (isOpen: boolean) => void;
  noteProps?: INoteProps;
}

export const NotesCompactView = ({
  compactPartNotes = [],
  totalNotes = [],
  hasManageNotes = true,
  manageNotesIsOpenExternal = false,
  updateManageNotesIsOpenExternal = null,
  addButton = null,
  listAddButton = null,
  noteProps = {},
}: IProps) => {
  const { t } = useTranslation();

  const getCompactListNotes = (notes: IManagedNote[]) =>
    notes.map(({ category, ...rest }) => ({
      ...rest,
      category: category ? { ...category, inline: true } : undefined,
    }));

  return (
    <Stack spacing={1}>
      <Notes
        notes={getCompactListNotes(compactPartNotes)}
        noteProps={{
          ...noteProps,
          textEllipsis: true,
          displayCard: false,
          displayActions: false,
        }}
      />
      <NotesMoreWrapper>
        <Tooltip
          title={
            <Notes
              notes={getCompactListNotes(totalNotes)}
              noteProps={{ ...noteProps, displayCard: false, displayActions: false }}
            />
          }
          color={Color.PRIMARY}
          placement={TooltipPosition.BOTTOM_START}
        >
          <Typography level={Level.BODY_SM} color={Color.PRIMARY}>
            {totalNotes.length > compactPartNotes.length &&
              t('labelMoreCount', { count: totalNotes.length - compactPartNotes.length })}
          </Typography>
        </Tooltip>

        {hasManageNotes && (
          <Stack direction={Direction.ROW} spacing={1}>
            {totalNotes.length > 0 && (
              <ManageNotesButton
                isOpenExternal={manageNotesIsOpenExternal}
                updateIsOpenExternal={updateManageNotesIsOpenExternal}
                notes={totalNotes}
                addButton={addButton}
                noteProps={noteProps}
              />
            )}
            {listAddButton}
          </Stack>
        )}
      </NotesMoreWrapper>
    </Stack>
  );
};
